import StarRating from './StarRating.svelte';

export default StarRating;
